// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qbRA","question":"styles_question__qSkCP","description":"styles_description__2fSMo"};